// PaginatorTemplate.js
import React from 'react';
import { Dropdown } from 'primereact/dropdown';

const PaginatorTemplate = ({ handleOnRowsChange, handleOnPageChange, currentPage, totalRecords, rows }) => ({
    layout: 'RowsPerPageDropdown CurrentPageReport',
    RowsPerPageDropdown: (options) => {
        const dropdownOptions = [
            { label: 5, value: 5 },
            { label: 10, value: 10 },
            { label: 20, value: 20 },
            { label: 50, value: 50 }
        ];

        return (
            <div className='paginatorLeft'>
                <span className="mx-1" style={{ color: 'var(--text-color)', userSelect: 'none' }}>
                    Rows per page{' '}
                </span>
                <Dropdown
                    value={options.value}
                    options={dropdownOptions}
                    onChange={(e) => {
                        options.onChange(e);
                        handleOnRowsChange(e);
                    }}
                />
            </div>
        );
    },
    CurrentPageReport: (options) => {
        const totalPages = Math.ceil(totalRecords / rows);
        return (
            <div className='paginatorRight'>
                <span style={{ color: 'var(--text-color)', userSelect: 'none', textAlign: 'center' }}>
                    Pages {currentPage + 1} of {totalPages}
                    <i
                        className="pi pi-angle-double-left"
                        onClick={(e) => {
                            if (currentPage > 0) {
                                handleOnPageChange(0);
                            }
                        }}
                        style={{
                            cursor: currentPage > 0 ? 'pointer' : 'not-allowed',
                            color: currentPage > 0 ? '#667085' : 'lightgray',
                            fontSize: '24px',
                            margin: '0 10px'
                        }}
                    />
                    <i
                        className="pi pi-angle-left"
                        onClick={(e) => {
                            if (currentPage > 0) {
                                handleOnPageChange(currentPage - 1);
                            }
                        }}
                        style={{
                            cursor: currentPage > 0 ? 'pointer' : 'not-allowed',
                            color: currentPage > 0 ? '#667085' : 'lightgray', fontSize: "24px"
                        }}
                    />
                    <i
                        className="pi pi-angle-right"
                        onClick={(e) => {
                            if (currentPage + 1 < totalPages) {
                                handleOnPageChange(currentPage + 1);
                            }
                        }}
                        style={{
                            cursor: currentPage + 1 < totalPages ? 'pointer' : 'not-allowed',
                            color: currentPage + 1 < totalPages ? '#667085' : 'lightgray',
                            fontSize: "24px"
                        }}
                    />
                    <i
                        className="pi pi-angle-double-right"
                        onClick={(e) => {
                            if (currentPage + 1 < totalPages) {
                                handleOnPageChange(totalPages - 1);
                            }
                        }}
                        style={{
                            cursor: currentPage + 1 < totalPages ? 'pointer' : 'not-allowed',
                            color: currentPage + 1 < totalPages ? '#667085' : 'lightgray',
                            fontSize: '24px',
                            margin: '0 10px'
                        }}
                    />

                </span>
            </div>
        );
    },
    // NextPageLink: (options) => null, // This will be handled in CurrentPageReport
    // PrevPageLink: (options) => null  // This will be handled in CurrentPageReport
});

export default PaginatorTemplate;
